import { edmCampaign } from '@bingads-webui/edm-campaign';
import { isEmpty } from 'underscore';

const campaignCriterionTypeName = 'Model.CampaignCriterion';

export const readCampaignCriterions = ({
  cid,
  aid,
  campaignId,
  type,
}) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .CampaignCriterions
    .$cast(campaignCriterionTypeName)
    .get({
      filter: {
        where: type,
      },
    })
    .toPromise();


export const readDayTimeCriterions = ({
  cid,
  aid,
  campaignId,
}) =>
  readCampaignCriterions({
    cid,
    aid,
    campaignId,
    type: "isof(Criterion,'Model.DayTimeCriterion')",
  });


export const viewModelToBulkModelForAdSchedules = ({ campaignViewModel }) => {
  const targets = campaignViewModel.data.adSchedulesBulkUpsert || [];
  return targets.map((criterion) => {
    const Status = isEmpty(criterion) ? 'Active' : criterion.Status;
    if (campaignViewModel.data.Id) {
      return {
        ...criterion,
        Status,
        Campaign: {
          Id: campaignViewModel.data.Id,
        },
      };
    }
    return {
      ...criterion,
      Status,
      CampaignName: campaignViewModel.Name,
    };
  });
};

export const readLocationCriterions = ({
  cid,
  aid,
  campaignId,
}) =>
  readCampaignCriterions({
    cid,
    aid,
    campaignId,
    type: "isof(Criterion,'Model.LocationCriterion') or isof(Criterion,'Model.RadiusCriterion') or isof(Criterion,'Model.LocationIntentCriterion')",
  });

export const readDeviceCriterion = ({
  cid,
  aid,
  campaignId,
  adGroupId,
}) =>
  readCampaignCriterions({
    cid,
    aid,
    campaignId,
    adGroupId,
    type: "isof(Criterion,'Model.DeviceCriterion')",
  });
